export const ENSEMBL_PLATFORM = 'ensembl';
export const SOLIDARITY_PLATFORM = 'solidarity';
export const MY_CONVERSATIONS_API_URL = `/me/conversations`;
export const CONVERSATIONS_PER_PAGE = '30';
